import { Card, Link as ComponentLibraryLink, Icon } from '@ps/isp-web-component-library';
import { ChevronSmallRight } from '@ps/isp-web-component-library/icons/ChevronSmallRight';
import { Link, Translation } from '@ps/web-shared-components';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { ExpandablePanel, Title } from '@swf/sports/components';
import GroupedTemplatePanels from '@swf/sports/components/GroupedTemplatePanels/GroupedTemplatePanels';
import { SportsComponent } from '@swf/sports/components/SportsComponent/SportsComponent';
import useLiveDataPolling from '@swf/sports/hooks/useLiveDataPolling/useLiveDataPolling';
import { getEventTypesInPlayEventIdsMap } from '@swf/sports/utils/getEventTypesInPlayEventIdsMap';
import getEventsFromMarketTemplateData from '@swf/sports/utils/getEventsFromMarketTemplateData';

import { useSportsHomePageWidget } from '../../model';

import { TXTWCL_All_In_Play, TXTWCL_In_Play } from './InPlayEvents.messages.json';
import Tabs from './components/Tabs/Tabs';

export const InPlayEvents: React.FC = () => {
  const { widgetSelect } = useSportsHomePageWidget();
  const hasInPlayEvents = useSelector(widgetSelect.hasInPlayEvents);
  const tabs = useSelector(widgetSelect.inPlayTabsWithEventTypeSlugs);
  const events = useSelector(widgetSelect.events);
  const markets = useSelector(widgetSelect.markets);
  const competitions = useSelector(widgetSelect.competitions);
  const eventTypes = useSelector(widgetSelect.eventTypes);
  const selectedTab = useSelector(widgetSelect.selectedInPlayTab);

  const eventTypesEventIdsMap = useMemo(
    () =>
      getEventTypesInPlayEventIdsMap(
        getEventsFromMarketTemplateData(events, markets, competitions, eventTypes)
      ),
    [competitions, eventTypes, events, markets]
  );

  useLiveDataPolling({ eventTypesEventIdsMap });

  if (!selectedTab || !hasInPlayEvents) {
    return null;
  }

  return (
    <SportsComponent name="Sports Home In Play Events Component">
      <ExpandablePanel
        title={
          <Title isNested>
            <Translation {...TXTWCL_In_Play} />
          </Title>
        }
        isNested
      >
        {tabs.length ? <Tabs tabs={tabs} selectedTab={selectedTab} /> : null}
        <GroupedTemplatePanels groupedOn="COMPETITION" groups={selectedTab.groups} isNested />
        <Card isPadded>
          <ComponentLibraryLink variant="secondary" asChild isButtonLink>
            <Link
              alias="sportsInPlaySport"
              values={{
                eventTypeId: selectedTab.eventTypeId,
                eventTypeSlug: selectedTab.eventTypeSlug
              }}
            >
              <Translation {...TXTWCL_All_In_Play} />
              <Icon icon={ChevronSmallRight} size="x1" />
            </Link>
          </ComponentLibraryLink>
        </Card>
      </ExpandablePanel>
    </SportsComponent>
  );
};
